export const MobLogo = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='49'
    height='46'
    viewBox='0 0 49 46'
    fill='none'
  >
    <path
      d='M30.4184 0H18.5821C13.8889 0.00119322 9.36996 1.77072 5.93319 4.95307C2.49642 8.13543 0.39643 12.4948 0.0550978 17.1555C-0.286235 21.8162 1.15638 26.4328 4.09313 30.078C7.02988 33.7231 11.2432 36.1266 15.8866 36.8058C16.2734 39.2407 16.1123 41.7308 15.4152 44.0963C15.3327 44.3738 15.3336 44.6692 15.4177 44.9462C15.5018 45.2233 15.6655 45.4697 15.8885 45.6552C16.1116 45.8407 16.3843 45.9572 16.673 45.9903C16.9618 46.0234 17.2539 45.9716 17.5135 45.8414C20.6044 44.2882 24.9821 41.4322 27.3184 36.9977H30.4238C35.3287 36.9629 40.0208 34.9982 43.4766 31.5322C46.9323 28.0662 48.8713 23.3801 48.8706 18.4961C48.8699 13.6122 46.9295 8.92668 43.4727 5.46168C40.016 1.99668 35.3233 0.0333623 30.4184 0ZM24.2718 29.5963C23.823 29.5961 23.3881 29.441 23.0413 29.1574C22.6945 28.8738 22.4572 28.4792 22.3698 28.0409C22.2824 27.6026 22.3503 27.1477 22.5619 26.7537C22.7736 26.3596 23.1159 26.0508 23.5306 25.8799C23.9452 25.709 24.4066 25.6865 24.836 25.8163C25.2655 25.9461 25.6364 26.2201 25.8857 26.5917C26.135 26.9632 26.2472 27.4094 26.2032 27.8541C26.1592 28.2988 25.9618 28.7145 25.6444 29.0305C25.4643 29.2101 25.2503 29.3526 25.0147 29.4496C24.7792 29.5467 24.5267 29.5966 24.2718 29.5963ZM26.3954 20.2264C26.3954 20.2264 26.2027 20.2976 26.2027 20.4066V21.9211C26.2083 22.177 26.1625 22.4315 26.0679 22.6695C25.9734 22.9076 25.8321 23.1245 25.6523 23.3074C25.4725 23.4904 25.2578 23.6358 25.0208 23.735C24.7838 23.8342 24.5293 23.8854 24.2722 23.8854C24.0151 23.8854 23.7606 23.8342 23.5236 23.735C23.2867 23.6358 23.072 23.4904 22.8921 23.3074C22.7123 23.1245 22.571 22.9076 22.4765 22.6695C22.382 22.4315 22.3362 22.177 22.3417 21.9211V20.4075C22.351 19.5582 22.6273 18.7331 23.1317 18.0481C23.6361 17.3631 24.3433 16.8526 25.154 16.5884C25.7138 16.4042 26.1991 16.0452 26.5376 15.5646C26.8762 15.084 27.0501 14.5074 27.0334 13.9206C27.0001 13.2047 26.6927 12.5286 26.1744 12.0313C25.6561 11.534 24.9662 11.2532 24.2464 11.2466C23.7306 11.2476 23.2256 11.3941 22.79 11.6692C22.3544 11.9442 22.0061 12.3366 21.7853 12.8007C21.5562 13.2487 21.1601 13.5894 20.6817 13.75C20.2034 13.9105 19.6809 13.8781 19.2263 13.6596C18.7717 13.4411 18.4211 13.054 18.2498 12.5812C18.0785 12.1084 18.1 11.5876 18.3098 11.1304C18.8438 10.0193 19.6812 9.08033 20.7261 8.421C21.771 7.76168 22.9813 7.40862 24.2184 7.40223H24.2582C25.9754 7.41243 27.6223 8.08241 28.8553 9.27239C30.0884 10.4624 30.8124 12.0805 30.8762 13.7891C30.9225 15.1996 30.5106 16.5873 29.7018 17.7462C28.8929 18.9051 27.7302 19.7733 26.3864 20.2219L26.3954 20.2264Z'
      fill='url(#paint0_linear_104_2921)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_104_2921'
        x1='-4.08186e-05'
        y1='-10'
        x2='51.4598'
        y2='8.64694'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFDA70' />
        <stop offset='1' stopColor='#35C9EF' />
      </linearGradient>
    </defs>
  </svg>
);

export const DKLogo = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='73'
    height='69'
    viewBox='0 0 73 69'
    fill='none'
  >
    <path
      d='M45.3162 0H27.6826C20.6907 0.00178983 13.9584 2.65607 8.83833 7.42961C3.71824 12.2031 0.589683 18.7423 0.0811677 25.7333C-0.427348 32.7243 1.72186 39.6493 6.09701 45.1169C10.4722 50.5846 16.7491 54.19 23.6668 55.2086C24.2431 58.8611 24.0032 62.5962 22.9645 66.1444C22.8417 66.5607 22.843 67.0038 22.9683 67.4194C23.0936 67.8349 23.3374 68.2046 23.6698 68.4828C24.0021 68.7611 24.4084 68.9358 24.8385 68.9855C25.2687 69.0351 25.7039 68.9575 26.0906 68.7621C30.6955 66.4323 37.2173 62.1482 40.6979 55.4965H45.3243C52.6317 55.4443 59.6219 52.4973 64.7703 47.2983C69.9187 42.0993 72.8074 35.0701 72.8063 27.7442C72.8053 20.4183 69.9145 13.39 64.7646 8.19252C59.6147 2.99501 52.6236 0.0500435 45.3162 0ZM36.1591 44.3945C35.4905 44.3942 34.8426 44.1615 34.326 43.7361C33.8093 43.3107 33.4557 42.7188 33.3255 42.0614C33.1953 41.4039 33.2964 40.7216 33.6118 40.1305C33.9271 39.5394 34.4371 39.0763 35.0548 38.8199C35.6726 38.5635 36.3599 38.5298 36.9997 38.7244C37.6395 38.9191 38.1922 39.3301 38.5636 39.8875C38.935 40.4448 39.1021 41.1141 39.0366 41.7811C38.971 42.4482 38.6768 43.0718 38.204 43.5458C37.9356 43.8152 37.6168 44.0288 37.2659 44.1745C36.915 44.3201 36.5389 44.3949 36.1591 44.3945ZM39.3229 30.3396C39.3229 30.3396 39.0358 30.4464 39.0358 30.6099V32.8816C39.0441 33.2655 38.9758 33.6472 38.835 34.0043C38.6942 34.3614 38.4837 34.6867 38.2158 34.9611C37.9479 35.2356 37.628 35.4536 37.275 35.6025C36.9219 35.7513 36.5428 35.828 36.1597 35.828C35.7767 35.828 35.3976 35.7513 35.0445 35.6025C34.6914 35.4536 34.3716 35.2356 34.1037 34.9611C33.8358 34.6867 33.6253 34.3614 33.4845 34.0043C33.3437 33.6472 33.2754 33.2655 33.2837 32.8816V30.6112C33.2975 29.3372 33.7091 28.0996 34.4605 27.0721C35.212 26.0446 36.2656 25.2789 37.4734 24.8825C38.3074 24.6063 39.0303 24.0678 39.5348 23.3469C40.0392 22.626 40.2982 21.7612 40.2733 20.8809C40.2237 19.807 39.7658 18.7929 38.9936 18.047C38.2214 17.301 37.1936 16.8798 36.1213 16.8699C35.3529 16.8714 34.6006 17.0911 33.9516 17.5037C33.3026 17.9163 32.7836 18.5049 32.4547 19.2011C32.1135 19.873 31.5233 20.3842 30.8107 20.625C30.098 20.8658 29.3196 20.8171 28.6423 20.4894C27.9651 20.1616 27.4428 19.5809 27.1876 18.8717C26.9323 18.1626 26.9644 17.3813 27.2769 16.6956C28.0724 15.0289 29.32 13.6205 30.8767 12.6315C32.4335 11.6425 34.2365 11.1129 36.0795 11.1034H36.1388C38.6971 11.1186 41.1506 12.1236 42.9876 13.9086C44.8246 15.6936 45.9032 18.1207 45.9984 20.6836C46.0673 22.7994 45.4537 24.881 44.2486 26.6193C43.0436 28.3576 41.3115 29.66 39.3094 30.3329L39.3229 30.3396Z'
      fill='url(#paint0_linear_104_2448)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_104_2448'
        x1='-0.000977584'
        y1='-15'
        x2='76.7846'
        y2='12.6346'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFDA70' />
        <stop offset='1' stopColor='#35C9EF' />
      </linearGradient>
    </defs>
  </svg>
);

export const Arrow = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='20'
    height='26'
    viewBox='0 0 20 26'
    fill='none'
  >
    <path
      d='M1.28992 12.1616L18.455 1.00424C19.1203 0.571828 20 1.04925 20 1.84269V24.1573C20 24.9508 19.1203 25.4282 18.455 24.9958L1.28991 13.8384C0.683231 13.4441 0.683233 12.5559 1.28992 12.1616Z'
      fill='#35C9EF'
    />
  </svg>
);

export const Close = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='28'
    height='28'
    viewBox='0 0 28 28'
    fill='none'
  >
    <path
      d='M21 7L7 21'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M7 7L21 21'
      stroke='black'
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);
